import type { Appearance } from "@stripe/stripe-js";

const stylesForPaywallCheckoutCustomization = {
  variables: {
    borderRadius: "12px",
    colorPrimary: "#19283a",
  },
  rules: {
    [".AccordionItem"]: {
      padding: "1.5rem",
    },
    [".RadioIcon"]: {
      width: "18px",
    },
    [".RadioIconOuter"]: {
      stroke: "#D4D4D8",
    },
    [".RadioIconOuter--checked"]: {
      stroke: "#000000",
      strokeWidth: "28px",
    },
    [".RadioIconInner--checked"]: {
      r: "0",
    },
  },
};

const stripeElementsOptions: { appearance: Appearance } = {
  appearance: {
    theme: "stripe",
    variables: {
      spacingGridRow: "20px",
    },
    rules: {
      [".Label"]: {
        color: "rgb(59, 59, 59)",
        fontFamily: `system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        fontSize: "14px",
        fontWeight: "600",
        lineHeight: "20px",
        margin: "0",
        padding: "0",
      },
      [".Input"]: {
        backgroundColor: "rgb(255, 255, 255)",
        border: "1px solid rgb(229, 231, 235)",
        borderColor: "rgb(229, 231, 235)",
        borderRadius: "8px",
        borderStyle: "solid",
        borderWidth: "1px",
        boxShadow: "none",
        color: "rgb(59, 59, 59)",
        fontFamily: `system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "18px",
        margin: "0",
        marginTop: "4px",
        outline: "transparent solid 0px",
        outlineOffset: "0",
        padding: "12px 16px",
        transition: "none",
      },
      [".Input:focus"]: {
        border: "1px solid rgba(107, 114, 128)",
        borderColor: "rgba(107, 114, 128)",
        borderWidth: "1px",
        boxShadow: "none",
        outline: "transparent solid 0px",
        outlineOffset: "0",
        transition: "none",
      },
    },
  },
};

const defaultAppearance: Appearance = stripeElementsOptions.appearance;
export const customizedAppearance: Appearance = {
  ...defaultAppearance,
  variables: {
    ...defaultAppearance.variables,
    ...stylesForPaywallCheckoutCustomization.variables,
  },
  rules: {
    ...defaultAppearance.rules,
    ...stylesForPaywallCheckoutCustomization.rules,
  },
};
